import { useCallback } from 'react';
import { useAtomValue } from 'jotai';
import { socketConnectionAtom } from '../states/socket-connection';
import { SocketName } from '../typings/socket-connection';
import { reconnectSocketByName } from '../../infra/sockets/socket-registry';

const useReconnectSockets = () => {
  const socketConnectionState = useAtomValue(socketConnectionAtom);

  const reconnectDisconnected = useCallback(() => {
    Object.entries(socketConnectionState).forEach(([name, isConnected]) => {
      if (!isConnected) {
        reconnectSocketByName(name as SocketName);
      }
    });
  }, [socketConnectionState]);

  return reconnectDisconnected;
};

export default useReconnectSockets;
